export default __webpack_public_path__ + "static/media/casas.212a994a.png";